module.exports = __webpack_public_path__ + "static/media/16.c2c70f07.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/units/16.svg
// module id = 388
// module chunks = 14